import { render } from "./PagamentoModal.vue?vue&type=template&id=b3bda83e&scoped=true"
import script from "./PagamentoModal.vue?vue&type=script&lang=js"
export * from "./PagamentoModal.vue?vue&type=script&lang=js"

import "./PagamentoModal.vue?vue&type=style&index=0&id=b3bda83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3bda83e"]])

export default __exports__